export default __webpack_public_path__ + "static/media/ideathon.ac2194f2.jpeg";